import { render } from "./ResetPasswordModal.vue?vue&type=template&id=33f3e9e7"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts"
script.render = render

export default script